import { createAction } from '@reduxjs/toolkit';

import { withPayloadType } from 'utils';

export const loginStart = createAction(
  'LOGIN::START',
  withPayloadType<{ email: string; password: string }>(),
);
